import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { setSubChildId } from "Administrator/modules/AdministratorModule";

export default store => ({
  path: "continuum-levels-mapping",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "continuum-levels-mapping" */ "./components/ContinuumLevelsMapping"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter() {
    store.dispatch(setSubChildId("CONTINUUM_LEVELS_MAPPING"));
  },
  onLeave() {
    store.dispatch(setSubChildId(""));
  },
});
